export const dateTimeConstants = {
  INPUT_FORMAT: 'YYYY-MM-DDTHH:mm',
  DISPLAY_FORMAT: 'MMM DD, YYYY hh:mma',
  DISPLAY_DATE_ONLY_FORMAT: 'MMM DD, YYYY',
  DISPLAY_TIME_ONLY_FORMAT: 'hh:mma',
  DISPLAY_ALT_FORMAT: 'MM/DD/YY hh:mma',
  CALENDAR_DATE_TIME_FORMAT: 'YYYY.MM.DD hh:mma',
  CALENDAR_MONTH_FORMAT: 'MMMM YYYY'
};
